import Keycloak from 'keycloak-js'

const KEYCLOAK_URL = process.env.VUE_APP_KEYCLOAK_URL || '';
const KEYCLOAK_REALM = process.env.VUE_APP_KEYCLOAK_REALM || 'VoiceAPP';
const KEYCLOAK_CLIENT_ID = process.env.VUE_APP_KEYCLOAK_CLIENT_ID || 'VoiceAppClient';

const keycloak = new Keycloak({
    url: KEYCLOAK_URL,
    realm: KEYCLOAK_REALM,
    clientId: KEYCLOAK_CLIENT_ID,
})

export default keycloak
